import { createStore } from 'redux'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import allreducers from '../../reducers';
const persistConfig = {
    key: 'root',
    storage,
    blacklist:['LocationReducer','MapReducer']
  }

  const persistedReducer = persistReducer(persistConfig, allreducers)

  const exportStore = () => {
    let store = createStore(persistedReducer,window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__())
    let persistor = persistStore(store)
    return { store, persistor }
  }
  export default exportStore;